import { useEffect, useState } from 'react';
import { SVGPDP } from '../../../Svg/ProductPage';
import {
  showAffordWidget,
  showPricePerUnit,
} from '../../../Utils/CategoryPageUtils';
import { getProductName, isDesktopUser } from '../../../Utils/ProductUtils';
import { getShowPriceSection } from '../../../Utils/productPageUtils';
import { noCostEmiMinAmount } from '../../PaymentPage/PaymentModes/constants';
import AffordibilityWidget from '../../Product/AffordibilityWidget/AffordibilityWidget';
import HealthBundle from '../../Product/HealthBundle/HealthBundle';
import { ProductDetailsTopSection } from '../../Product/ImageGallaryCarousel/styled';
import { clicked_card_in_pdp } from '../../Product/ImageGallaryCarousel/utils';
import { InclTax, InclTaxNew } from '../../Product/ProductDetail/styled';
import { SkeletonBox } from '../../Product/Skeleton/styled';
import ProductFeatures from '../../ProductNew/ProductFeatures';
import NoCostEmi from '../NoCostEmi';
import ProductRating from '../ProductInfoNew/ProductRating';
import LightningComponent from './LightningSection/LightningComponent';
import PriceSection from './PriceSection';
import {
  FertilityDescriptionNew,
  FlexCenter,
  FreeDelivery,
  ProductName,
} from './styled';
import ProductImpacts from '../../ProductNew/ProductInfoNew/ProductImpacts';
import WrapperFeatures from './WrapperFeatures';
import {
  detergentCleanserComboFeatureData,
  detergentFeatureData,
  diaperFeatureData,
  lactoFeatureData,
  wrapperFeatureData,
} from '../../Product/FertilityTrustSection/constant';
import { getWebUserType } from '../../../Utils/getWebUserType';

export default function ProductDetail(props) {
  const {
    productData,
    priceData,
    showLighteningDeal,
    clinic,
    isFertilityProduct,
    setOpenWidgetOnClick,
    explorePage,
    showNewDiaperVariantUx,
    isWrapperPdp,
    isLactoPdp,
    isDetergentProduct,
    isDetergentCleanserComboProduct,
  } = props;
  const [userType, setUserType] = useState();
  const [lowOpacity, setLowOpacity] = useState();
  useEffect(() => {
    setUserType(getWebUserType());
  }, []);
  //  const lightining = productData?.dealName && showLighteningDeal;
  // const lightining = true;
  const feature = productData?.product_feature;
  const showNewPriceSection = getShowPriceSection(userType);

  const onClickOfFertilitText = () => {
    clicked_card_in_pdp(
      undefined,
      undefined,
      productData,
      undefined,
      'ingredients_text',
    );

    setLowOpacity('lowOpac');
    let offSet = document.getElementById('ingredients').offsetTop;
    offSet -= isDesktopUser() ? 100 : 10;
    setOpenWidgetOnClick('ingredients');
    window.scrollTo({
      top: offSet,
      behavior: 'smooth',
    });
    setTimeout(() => {
      setLowOpacity();
      setOpenWidgetOnClick(null);
    }, [1000]);
  };

  return (
    <>
      <ProductDetailsTopSection
        hideSection={isFertilityProduct || showNewDiaperVariantUx}
      >
        <ProductName isFertilityProduct={isFertilityProduct}>
          {getProductName(productData)}
        </ProductName>
        {feature && !isFertilityProduct ? (
          <p className="features">{feature}</p>
        ) : null}
        {isFertilityProduct && (
          <FertilityDescriptionNew
            desktop={true}
            // onClick={onClickOfFertilitText}
            // clickable={userType === "B"}
          >
            Combines the ancient power of Shatavari with expert-backed CoQ10 and
            L-Methylfolate
          </FertilityDescriptionNew>
        )}
        {/* {productData?.description ? productData?.description : null} */}

        {productData?.avg_rating > 0 ? (
          <ProductRating
            productData={productData}
            width={'18px'}
            height={'18px'}
            fontS={'14px'}
            // showToast={showToast}
            // setShowToast={setShowToast}
            showNewPriceSection={showNewPriceSection}
            isFertilityProduct={isFertilityProduct}
          />
        ) : null}
        {productData?.features && !isFertilityProduct && (
          <ProductFeatures productData={productData} />
        )}
        {isFertilityProduct && <ProductImpacts />}
        {isWrapperPdp ||
        isLactoPdp ||
        showNewDiaperVariantUx ||
        isDetergentProduct ||
        isDetergentCleanserComboProduct ? (
          <WrapperFeatures
            featureData={
              isLactoPdp
                ? lactoFeatureData
                : showNewDiaperVariantUx
                  ? diaperFeatureData
                  : isDetergentProduct
                    ? detergentFeatureData
                    : isDetergentCleanserComboProduct
                      ? detergentCleanserComboFeatureData
                      : wrapperFeatureData
            }
            isDetergentProduct={isDetergentProduct}
          />
        ) : null}

        {/* {isFertilityProduct && (
                    <FertilityDescription
                        onClick={onClickOfFertilitText}
                        className={lowOpacity}
                        clickable={userType === "B"}
                    >
                        <p>
                            Combines the ancient{" "}
                            <span>
                                power of Shatavari with scientifically-backed
                            </span>{" "}
                            CoQ10 and L-Methylfolate
                        </p>
                    </FertilityDescription>
                )} */}
      </ProductDetailsTopSection>
      {/* <DesktopHidden>
                {isFertilityProduct && (
                    <FertilityDescription
                        onClick={onClickOfFertilitText}
                        className={lowOpacity}
                        clickable={userType === "B"}
                    >
                        <p>
                            Combines the ancient{" "}
                            <span>
                                power of Shatavari with scientifically-backed
                            </span>{" "}
                            CoQ10 and L-Methylfolate
                        </p>
                    </FertilityDescription>
                )}
            </DesktopHidden> */}

      {productData?.isWebBundle || isFertilityProduct || isDetergentProduct ? (
        <HealthBundle
          productId={productData?.id}
          data={productData?.variantData.filter((obj) => obj.id != 3960)}
          isFertilityProduct={isFertilityProduct}
          isDetergentProduct={isDetergentProduct}
          userType={userType}
        />
      ) : !showNewDiaperVariantUx ? (
        priceData ? (
          <PriceSection
            userType={userType}
            productData={productData}
            showNewPriceSection={showNewPriceSection}
            isWrapperPdp={isWrapperPdp}
          />
        ) : (
          <SkeletonBox height="30px" width="170px" />
        )
      ) : null}
      {isFertilityProduct && (
        <InclTaxNew>
          (M.R.P. incl of all taxes). Additional Charges may apply on discounted
          prices
        </InclTaxNew>
      )}
      {!isFertilityProduct ? (
        productData?.isWebBundle ? (
          <InclTax>
            (incl. of all taxes each, Add&apos;l charges may apply on discounted
            price)
          </InclTax>
        ) : !showPricePerUnit(userType, productData?.pricePerUnit) ? (
          <InclTax>
            (incl. of all taxes, Add&apos;l charges may apply on discounted
            price)
          </InclTax>
        ) : null
      ) : null}
      {showLighteningDeal ? (
        <LightningComponent productData={productData} userType={userType} />
      ) : null}
      {!showAffordWidget(userType, productData?.id) &&
      productData?.price > noCostEmiMinAmount ? (
        <NoCostEmi price={productData?.price} />
      ) : null}
      {productData?.price >= productData?.freeShppingPrice &&
        !isFertilityProduct &&
        !showNewDiaperVariantUx && (
          <FlexCenter padding="8px 0px" clinic={clinic}>
            <SVGPDP id="deliverycheck" width="15px" height="15px" />
            <FreeDelivery>Free delivery for this order</FreeDelivery>
          </FlexCenter>
        )}
      {showAffordWidget(userType, productData?.id) &&
      productData?.price > noCostEmiMinAmount ? (
        <AffordibilityWidget
          productId={productData?.id}
          price={productData?.price}
        />
      ) : null}
    </>
  );
}
